var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",domProps:{"innerHTML":_vm._s(_vm.$t('accountSettings-limit-content'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }